<template>
  <!-- <pre v-if="responseData"> testData={{ lampuJalan }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/LAMPU JALAN.png"
        alt="LAMPU JALAN"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>BILANGAN LAMPU JALAN</h2>

      <!-- Wrap ALL items inside one .lampu div -->
      <div class="lampu">
        <!-- First Image -->
        <div class="lampu-container">
          <img
            src="@/assets/lampu/son.png"
            alt="Second Image"
            class="responsive-image"
          >
          <div class="overlay-text">
            <h3>BILANGAN LAMPU JALAN JENIS (HPSV/SON)</h3>
            
            <p class="number">
              {{ numberWithCommas(lampuJalan.bilangan_lampu_jalan_biasa) }}
            </p>
          </div>
        </div>

       

        <!-- Second Image -->
        <div class="lampu-container">
          <img
            src="@/assets/lampu/led.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="overlay-text">
            <h3>BILANGAN LAMPU JALAN JENIS</h3>
            <h3>(LED)</h3>
            
            <p class="number">
              {{ numberWithCommas(lampuJalan.bilangan_lampu_jalan_led) }}
            </p>
          </div>
        </div>

        <!-- Third Image (Moved inside .lampu div) -->
        <div class="lampu-container">
          <img
            src="@/assets/lampu/solar.png"
            alt="Third Image"
            class="responsive-image"
          >
          <div class="overlay-text">
            <h3>BILANGAN LAMPU JALAN JENIS SOLAR</h3>
            <p class="number">
              {{ numberWithCommas(lampuJalan.bilangan_lampu_jalan_solar) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="content-wrapper">
      <h2>BILANGAN LAMPU JALAN MENGIKUT NEGERI</h2>
      
      <div class="chart-wrapper">
        <BarLampu
          :chart-data="LampuData"
          :chart-categories="LampuNames"
          :chart-colors="['#42a5f5']"  
        />
        <Update />
      </div> 
    </div>
  </AdminBackground>
  <PrimaryModule />
  <KejuruteraanKesihatanMenu />  
</template>



<script setup>
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'

const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2024)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

const LampuData = ref([])
const LampuNames = ref([])


//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion } = useHttpService()




const lampuJalan = ref({
  lampuJalan: {
    // eslint-disable-next-line camelcase
    bilangan_lampu_jalan_biasa: 0,
    // eslint-disable-next-line camelcase
    bilangan_lampu_jalan_led: 0,
    // eslint-disable-next-line camelcase
    bilangan_lampu_jalan_solar: 0,
  },

})

const responseData = ref(null)


async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

    // Ensure we're working with a plain array for states
    const plainStates = toRaw(state)

    // Create query parameters for year and states
    // Create the query parameters manually
    let queryParams = `year=${year}`
    console.log('Plain states:', plainStates)

    // Check if states are "Semua Negeri" and skip appending states[] if true
    if (!plainStates.includes("Semua Negeri")) {
      // Append each state to the query string with the desired 'states[]' format
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    // Append councils[] if pbtValue is selected
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      // Append each PBT in the array to the query parameters
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // Construct the URL with the query parameters
    const url = `kejuruteraan-kesihatan-umum/lampu-jalan?${queryParams}`

    const response = await httpGet(url)

    years.value = response.years

    states.value = ["Semua Negeri"] // Reset with default option
    if (Array.isArray(response.states)) {
      response.states.forEach(state => {
        if (state && state !== "Modified Pbt") {
          states.value.push(state)
        }
      })
    } else if (response.states && typeof response.states === 'object') {
      Object.values(response.states).forEach(state => {
        if (state && state !== "Modified Pbt") {
          states.value.push(state)
        }
      })
    } else {
      console.warn("Expected response.states to be an array or object, but received:", response.states)
    }


    councils.value = response.councils
    responseData.value = response
    lampuJalan.value = response.data.keseluruhan

   
    lampuJalan.value.lampuJalan = {
      // eslint-disable-next-line camelcase
      bilangan_lampu_jalan_biasa: lampuJalan.value ? numberWithCommas(lampuJalan.value.bilangan_lampu_jalan_biasa) : 0,
      // eslint-disable-next-line camelcase
      bilangan_lampu_jalan_led: lampuJalan.value ? numberWithCommas(lampuJalan.value.bilangan_lampu_jalan_led) : 0,
      // eslint-disable-next-line camelcase
      bilangan_lampu_jalan_solar: lampuJalan.value ? numberWithCommas(lampuJalan.value.bilangan_lampu_jalan_solar) : 0,
    }
    updateChartData()

  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function updateChartData() {
  // Access state-level data from the response
  const statesData = responseData.value?.data?.data

  if (!statesData) {
    LampuNames.value = []
    LampuData.value = []
    
    return
  }

  // Extract state names and sum up "jumlah" for each state
  LampuNames.value = Object.keys(statesData) // State names like Johor, Kedah, etc.
  LampuData.value = LampuNames.value.map(state => {
    const councils = statesData[state] // Get councils under the state
    
    return Object.values(councils).reduce((sum, council) => sum + (council.jumlah || 0), 0) // Sum up "jumlah"
  })

  console.log("LampuNames:", LampuNames.value)
  console.log("LampuData:", LampuData.value)
}




function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}

onMounted(() => {
  loadDataFromApi()
  
})

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state) 
watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px; 
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); 
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; /* Adjusted size */
  height: auto;
}

.line-under-image {
  width: 70%; /* Match width to the image size */
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}


/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}


.lampu {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;

  gap: 50px; 
}

.lampu-container {
  flex: 0 0 auto; 
  width: 30%; 
  min-width: 300px; 
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.lampu-container img {
  width: 100%;
  height: auto;
  display: block;
}

.overlay-text {
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
  text-align: center;
  color: white;
  padding: 10px;
}

.overlay-text h3 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: black;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
}
.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1200px;
}

/* For larger screens, up to 1024px */
@media (max-width: 1024px) {
  .lampu {
    gap: 30px; /* Reduce gap to fit screen */
    flex-wrap: wrap;
    justify-content: center; /* Center-align elements */
  }

  .lampu-container {
    width: 45%; /* Adjust width to allow for two columns */
    min-width: 250px;
  }

  .overlay-text h3 {
    font-size: 16px; /* Adjust font size */
  }

  .number {
    font-size: 20px; /* Adjust font size */
  }
}

/* For medium screens, up to 768px */
@media (max-width: 768px) {
  .lampu {
    flex-direction: column; /* Stack items vertically */
    align-items: center;
    gap: 20px;
  }

  .lampu-container {
    width: 80%; /* Full width of the container */
  }

  .overlay-text h3 {
    font-size: 14px;
  }

  .number {
    font-size: 18px;
  }
}


@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  h2 {
    font-size: 1.2rem;
  }

  .lampu-container {
    width: 100%; 
    margin-bottom: 15px; 
  }

  .overlay-text {
    bottom: 5px;
    padding: 5px;
  }

  .overlay-text h3 {
    font-size: 12px;
    line-height: 1.2;
  }

  .number {
    font-size: 16px;
  }
}
</style>
